import { render, staticRenderFns } from "./ResizableFrame.vue?vue&type=template&id=44ea26f9&scoped=true&"
import script from "./ResizableFrame.vue?vue&type=script&lang=js&"
export * from "./ResizableFrame.vue?vue&type=script&lang=js&"
import style0 from "./ResizableFrame.vue?vue&type=style&index=0&id=44ea26f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ea26f9",
  null
  
)

export default component.exports